document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector('.environment__more--display')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('environment__more--display'))
        return;

      document
        .querySelectorAll('.environment__description--hidden')
        .forEach((el) => {
          el.style.display = 'block';
        });

      document.querySelector(
        '.environment__description--display'
      ).style.display = 'none';

      event.target.style.display = 'none';

      document.querySelector('.environment__more--hidden').style.display =
        'flex';
    });

  document
    .querySelector('.environment__more--hidden')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('environment__more--hidden')) return;

      document
        .querySelectorAll('.environment__description--hidden')
        .forEach((el) => {
          el.style.display = 'none';
        });

      document.querySelector(
        '.environment__description--display'
      ).style.display = 'block';

      event.target.style.display = 'none';

      document.querySelector('.environment__more--display').style.display =
        'flex';
    });

  document.querySelectorAll('.performance__more--display').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (!event.target.classList.contains('performance__more--display'))
        return;

      if (window.matchMedia('(max-width: 767px)').matches) {
        console.log('sp');
        document
          .querySelectorAll('.performance__image--hidden--sp')
          .forEach((el) => {
            el.style.display = 'block';
          });
      } else {
        document
          .querySelectorAll('.performance__image--hidden--pc')
          .forEach((el) => {
            el.style.display = 'block';
          });
      }

      document
        .querySelectorAll('[data-target="transparent-target"]')
        .forEach((el) => {
          el.classList.remove('performance__image--transparent');
        });

      event.target.style.display = 'none';

      document.querySelectorAll('.performance__more--hidden').forEach((el) => {
        el.style.display = 'flex';
      });
    });
  });

  document.querySelectorAll('.performance__more--hidden').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (!event.target.classList.contains('performance__more--hidden')) return;

      if (window.matchMedia('(max-width: 767px)').matches) {
        document
          .querySelectorAll('.performance__image--hidden--sp')
          .forEach((el) => (el.style.display = 'none'));
      } else {
        document
          .querySelectorAll('.performance__image--hidden--pc')
          .forEach((el) => {
            el.style.display = 'none';
          });
      }

      document
        .querySelectorAll('[data-target="transparent-target"]')
        .forEach((el) => {
          el.classList.add('performance__image--transparent');
        });

      event.target.style.display = 'none';

      document.querySelectorAll('.performance__more--display').forEach((el) => {
        el.style.display = 'flex';
      });
    });
  });
});
